import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card_title, { style: {"text-align":"start","white-space":"break-spaces"} }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.i18n.t('texts.access')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userStore.services, (service) => {
          return (_openBlock(), _createBlock(_component_v_card, {
            key: service.name + '_' + service.instance,
            style: {"margin-bottom":"4px"},
            variant: "elevated",
            href: service.gui
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { style: {"white-space":"break-spaces"} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(service.name) + " - " + _toDisplayString(service.instance), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["href"]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}